import React from 'react';

export default function MaterialIcon({ type, className, size = 24, weight = 400 }) {
    const iconSizeClass = `text--${size}`;

    const iconStyle = weight !== 400 ? {
        fontVariationSettings: `'FILL' 0, 'wght' ${weight}, 'GRAD' 0, 'opsz' ${size}`,
    } : {};

    return (
        <span
            className={`material-symbols-rounded material-symbols-outlined icon ${iconSizeClass}${className ? ` ${className}` : ''}`}
            style={iconStyle}
        >
            {type}
        </span>
    );
}
